import logoAsset from "@/assets/glow-long-logo.png.asset.json";

export function Logo({ className }: { className?: string }) {
  return (
    <img
      src={logoAsset.url}
      alt="Glow Long Golf"
      className={className}
      width={96}
      height={96}
      loading="eager"
      decoding="async"
    />
  );
}
